import React from 'react'
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    page: {
      padding: 10,
      fontSize: 12,
      fontFamily: 'Helvetica',
    },
    headingContainer: {
      flexDirection: 'row',
      alignItems: 'center', 
      marginBottom: 10,
    },
    headingTitle: {
      fontSize: 16,
      fontWeight: 'bold',
    },
    headingText: {
      marginTop: 5,
      fontSize: 14,
    },
    section: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      marginBottom: 10,
    },
    label: {
      width: '50%',
      padding: 5,
      fontSize: 12,
      fontWeight: 'bold',
    },
    value: {
      width: '50%',
      padding: 5,
      fontSize: 12,
    },
    productRow: {
      flexDirection: 'row',
      padding: 5,
    },
    productHeader: {
      backgroundColor: '#1e90ff',
      color: '#fff',
      padding: 5,
      fontSize: 12,
      fontWeight: 'bold',
    },
    productCell: {
      padding: 5,
      fontSize: 12,
    },
    note: {
      marginTop: 20,
      padding: 10,
      borderWidth: 1,
      flexDirection: 'row',
      justifyContent: 'space-between', 
      borderColor: '#ccc',
    },
  });

const DownloadSo = ({ data }) => {
    return(
        <Document>
        <Page size="A4" style={styles.page} orientation="portrait">
          <View style={styles.headingContainer}>
            <Text style={styles.headingTitle}>Sales Order</Text>
            <Text style={styles.headingText}>: {data.ref}</Text>
          </View>
    
          <View style={styles.section}>
            {[
              { label: 'Customer Order ', value: data.cusOrderRef },
              { label: 'Customer Discount ', value: data.cusDiscount },
              { label: 'Date', value: data.date || 'N/A'},
              { label: 'Purchase Requests', value: data.prRef || 'N/A'},
              { label: 'Customer', value: data.customerName || 'N/A'},
              { label: 'Payment Status ', value: data.paymentStatus || 'N/A'},
              { label: 'Approval Status', value: data.approvalStatus || 'N/A'},
              { label: 'Approval By ', value: data.approvedByName || 'N/A'},
              { label: 'Requested By', value: data.requestedByName || 'N/A'},
              { label: 'Requested Delivery Date', value: data.requestedDeliveryDate || 'N/A'},
              { label: 'Shipping method', value: data.shippingMethod || 'N/A'},
              { label: 'Shipping Instruction', value: data.shippingInstruction || 'N/A'},
              { label: 'Terms and Conditions', value: data.termsAndConditions || 'N/A'},
              { label: 'Delivery Address', value: data.deliveryAddress || 'N/A'},
              { label: 'Billing Address', value: data.billingAddress || 'N/A'},
    
                   ].map((item, index) => (
              <View key={index} style={{ flexDirection: 'row' }}>
                <Text style={styles.label}>{item.label}</Text>
                <Text style={styles.value}>{item.value}</Text>
              </View>
            ))}
          </View>
    
          <View style={{ marginTop: 20, backgroundColor: '#D3D3D3' }}>
            <View style={{ flexDirection: 'row' }}>
              {[
                'S.N',  'Item Code','Product Name', 'Product Unit',
                'Quantity', 'Price'
              ].map((header, index) => {
                let width=[5, 15, 30, 10,20, 20, ]
                return(
                <Text key={index} style={[styles.productHeader, { width: `${width[index]}%` }]}>
                  {header}
                </Text>
              )})}
            </View>
            {data?.products?.map((product, index) => (
              <View key={index} style={styles.productRow}>
                <Text style={[styles.productCell, { width: '5%' }]}>{(index+1)}</Text>
                <Text style={[styles.productCell, { width: '15%' }]}>{product.item_code}</Text>
                <Text style={[styles.productCell, { width: '30%' }]}>{product.product_name}</Text>
                <Text style={[styles.productCell, { width: '10%' }]}>{product.unit}</Text>
                {/* <Text style={[styles.productCell, { width: '15%' }]}>{product.product_category}</Text> */}
                {/* <Text style={[styles.productCell, { width: '20%' }]}>{product.requestedQty}</Text> */}
                <Text style={[styles.productCell, { width: '20%' }]}>{product.quantity}</Text>
                <Text style={[styles.productCell, { width: '20%' }]}>{product.price}</Text>
                {/* <Text style={[styles.productCell, { width: '15%' }]}>{product.totalPrice}</Text> */}
              </View>
            ))}
          </View>
    
          <View style={styles.note}>
            {/* <Text>Note From Customer: {data.notesFromCus || 'N/A'}</Text> */}
    
            <Text>Total Price: {data.subTotal}</Text>
          </View>
        </Page>
      </Document>
    )

}

export default DownloadSo